import httpService from "./httpService";

const base = "/webcall";

function getLivekitConnectionDetails({ workspaceId, assistantId }) {
  return httpService.get(
    `${base}/whitelabelGetWebcallToken/${workspaceId}/${assistantId}`
  );
}

export { getLivekitConnectionDetails };
